import { useEffect, useState } from 'react'

import type { CommonSite } from '@awaze/mfe-common.types-and-mocks.site-search-service'
import { Brand } from '@awazevr/design-system.components.awaze-theme-provider'
import type { Deposit, Deposits } from '@awazevr/mfe-common.configs.brand'
import { getActiveDepositScheme } from '@awazevr/mfe-common.configs.brand'

import { getEndDateFromStartDateDuration } from '@/utils/getEndDateFromStartDateDuration'

interface UseGetActiveDepositSchemeArgs {
  brand: Brand
  country: string
  deposits: Deposits
  propertyInfo: CommonSite | null
}

interface UseGetActiveDepositSchemeReturn {
  activeDeposit: Deposit | null
}

export const useGetActiveDepositScheme = ({
  brand,
  country,
  deposits,
  propertyInfo,
}: UseGetActiveDepositSchemeArgs): UseGetActiveDepositSchemeReturn => {
  const [activeDeposit, setActiveDeposit] = useState<Deposit | null>(null)

  useEffect(() => {
    if (propertyInfo?.startDate) {
      const dateToday = new Date()
      dateToday.setUTCHours(0, 0, 0, 0)
      const isSite = propertyInfo?.cardinality === 'MULTI'
      const cottageType = brand === 'novasol' ? 'novasol_cottages' : 'cottages'
      const accommodationType = isSite ? 'accom' : cottageType
      const sleeps = isSite ? 0 : (propertyInfo?.property?.sleeps ?? 0)
      const bookingPrice = isSite
        ? (propertyInfo.priceFrom ?? 0)
        : (propertyInfo?.price ?? 0)

      const startDate = new Date(propertyInfo.startDate)

      const endDate = getEndDateFromStartDateDuration(
        startDate,
        propertyInfo?.lengthOfStay ?? 0,
      )

      const activeDeposit = getActiveDepositScheme(
        deposits,
        dateToday,
        startDate,
        endDate,
        sleeps,
        bookingPrice,
        accommodationType,
        country,
      )

      setActiveDeposit(activeDeposit)
    } else {
      setActiveDeposit(null)
    }
  }, [propertyInfo])

  return { activeDeposit }
}
